<template>
	<div>
		<el-dialog
			:visible.sync="projectReviewDialog"
			:before-close="handleClose"
			title="Project Review"
			:fullscreen="false"
			width="650px"
			class="header"
			:close-on-press-escape="false"
			:destroy-on-close="true"
		>
			<div style="margin-top: 15px">
				<el-row style="margin-top: 0px">
					<el-col :span="6" :offset="1">
						<div><b>Location name</b></div>
					</el-col>
					<el-col :span="16" :offset="1">
						<span style="text-transform: capitalize; word-break: break-word">
							{{
								project_info_object.location_info
									? project_info_object.location_info.name
									: ""
							}}</span
						>
					</el-col>
				</el-row>
				<el-row style="margin-top: 20px">
					<el-col :span="6" :offset="1">
						<div><b>Project name</b></div>
					</el-col>
					<el-col :span="16" :offset="1">
						<span style="text-transform: capitalize; word-break: break-word">{{
							project_info_object.project_name
						}}</span>
					</el-col>
				</el-row>
				<el-row style="margin-top: 20px">
					<el-col :span="6" :offset="1">
						<div><b>Points</b></div>
					</el-col>
					<el-col :span="16" :offset="1">
						{{
							project_info_object.task_status_update_info
								? project_info_object.task_status_update_info.current_score
								: ""
						}}
						of
						{{
							project_info_object.task_status_update_info
								? project_info_object.task_status_update_info.total_score
								: ""
						}}
						( 100% )
					</el-col>
				</el-row>
				<el-row style="margin-top: 20px">
					<el-col :span="6" :offset="1">
						<div><b>Remarks </b></div>
					</el-col>
					<el-col :span="15" :offset="1">
						<el-input
							type="textarea"
							:rows="4"
							placeholder="Enter Remarks"
							v-model="remarks"
							class="input-class"
							:minlength="0"
							:maxlength="350"
							show-word-limit
						>
						</el-input>
					</el-col>
				</el-row>
				<el-row style="margin-top: 20px">
					<el-col :span="6" :offset="1">
						<div><b>Auditee Signature</b></div>
					</el-col>
					<el-col :span="15" :offset="1">
						<div style="border: 1px solid" id="app">
							<canvas
								v-if="auditee_sign_file_path_url == null"
								ref="signatureCanvasAuditee"
							></canvas>
							<img
								v-if="auditee_sign_file_path_url != null"
								class="uploaded-image"
								:src="auditee_sign_file_path_url"
								alt="Image Preview"
								id="preview-img"
							/>
						</div>
						<el-row style="margin-top: 0px">
							<el-col :span="9" :offset="15">
								<el-button
									@click="handleAuditeeClick"
									class="button-class-white2"
									style="border: none"
								>
									Clear Signature
								</el-button>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row style="margin-top: 30px">
					<el-col
						:span="3"
						:offset="project_info_object.is_submitted ? 16 : 16"
					>
						<el-button
							@click="$emit('close')"
							class="button-class-white2"
							style="border: none"
							:loading="loading"
						>
							Cancel
						</el-button>
					</el-col>
					<!-- 
						v-if="!project_info_object.is_submitted"
                     -->
					<el-col style="margin-bottom: 40px" :span="3" :offset="1">
						<el-button
							:loading="loading"
							class="button-class"
							@click="save_project_review()"
						>
							Update
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import SignaturePad from "signature_pad";
import formBuilderServices from "../../../../services/formBuilderServices";

export default {
	props: {
		projectReviewDialog: Boolean,
		project_info_object: Object,
	},
	components: {
		SignaturePad,
	},
	data: () => ({
		remarks: "",
		signaturePadAuditee: null,
		loading: false,
		auditee_sign_file_path_url: null,
	}),
	watch: {
		async projectReviewDialog(val) {
			if (val) {
				this.remarks = this.project_info_object.review;
				if (this.project_info_object.auditee_sign_file_path != null) {
					let params = {
						file_path: this.project_info_object.auditee_sign_file_path,
						storage: "task",
					};
					const res = await formBuilderServices.getAttachmentURL(params);
					this.auditee_sign_file_path_url = JSON.parse(res.data).data;
				} else {
					this.initSignaturePadAuditee();
				}
			}
		},
	},
	methods: {
		handleAuditeeClick() {
			if (this.auditee_sign_file_path_url) {
				this.auditee_sign_file_path_url = null;
				this.initSignaturePadAuditee();
			} else {
				this.clearSignatureAuditee();
			}
		},
		async save_project_review() {
			this.loading = true;
			if (this.signaturePadAuditee) {
				await this.saveSignatureAuditee();
			}
			let params = {
				project_id: this.project_info_object.id,
				auditee_sign_file_path:
					this.auditee_sign_file_path_url == null
						? this.signaturePadAuditeeUploaded != null
							? this.signaturePadAuditeeUploaded[0].file_path
							: null
						: this.project_info_object.auditee_sign_file_path,
				review: this.remarks.length == 0 ? null : this.remarks,
			};

			formBuilderServices.projectReview(params).then((res) => {
				this.$notify.success({
					title: "Success",
					message: "Project Review Submitted Successfully",
				});
				this.$emit("clicked");
				this.loading = false;
			});
		},
		async saveSignatureAuditee() {
			try {
				if (this.signaturePadAuditee) {
					if (this.signaturePadAuditee.isEmpty()) {
						this.signaturePadAuditeeUploaded = null;
						this.loading = false;
						return;
					}
					const dataURL = this.signaturePadAuditee.toDataURL();
					const blob = this.dataURLToBlob(dataURL);
					const file = new File(
						[blob],
						`Auditee signature ${Math.floor(new Date().getTime() / 1000)}.png`,
						{ type: "image/png" }
					);
					const formData = new FormData();
					formData.append("attachments", file);
					formData.append("storage", "task");
					const res = await formBuilderServices.uploadImageAttachment(formData);
					this.signaturePadAuditeeUploaded = JSON.parse(res.data).data;
				}
			} catch (error) {
				console.error("Error in saveSignature:", error);
			}
		},
		dataURLToBlob(dataURL) {
			const parts = dataURL.split(";base64,");
			const contentType = parts[0].split(":")[1];
			const raw = window.atob(parts[1]);
			const array = new Uint8Array(new ArrayBuffer(raw.length));
			for (let i = 0; i < raw.length; i++) {
				array[i] = raw.charCodeAt(i);
			}
			return new Blob([array], { type: contentType });
		},
		initSignaturePadAuditee() {
			setTimeout(() => {
				const canvas1 = this.$refs.signatureCanvasAuditee;
				this.$forceUpdate();
				if (canvas1) {
					this.signaturePadAuditee = new SignaturePad(canvas1);
				} else {
					console.error("Canvas element not found.1");
					this.$emit("reopen");
				}
			}, 1000);
		},
		clearSignatureAuditee() {
			if (this.signaturePadAuditee) {
				this.signaturePadAuditee.clear();
			}
		},
		handleClose() {
			this.$emit("close");
		},
	},
};
</script>

<style></style>
